import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

// Client-side guard for standalone tabs (HR/Referrals) that stay on the
// existing role/permission system rather than the paid-module subscription one.
export default function PermissionGate({ module, moduleName, children }) {
  const { can, loading } = usePermissions();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#94a3b8', fontSize: 14 }}>
        Checking access…
      </div>
    );
  }

  if (!can(module, 'view')) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', textAlign: 'center', padding: 24 }}>
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0f1f45', margin: '0 0 8px' }}>
            You don't have access to {moduleName || 'this module'}
          </h3>
          <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>
            Ask your admin to grant this permission under Settings → User Roles.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
